import { arrayOf, enumOf, objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

import { daysOfWeek } from "@lib/getNextDateFromDaysOfWeek";
import type { DaysOfWeek } from "@lib/getNextDateFromDaysOfWeek";

import type {
  GetDecisioningStudioAgentsAppGroupIdDsaIdScheduleResult,
  PutDecisioningStudioAgentsAppGroupIdDsaIdScheduleResult,
} from "./types";

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdScheduleResult =
  objectOf<GetDecisioningStudioAgentsAppGroupIdDsaIdScheduleResult>({
    frequency: number,
    days_of_week: arrayOf(enumOf<DaysOfWeek>(...(daysOfWeek as DaysOfWeek[]))),
  });

export const isPutDecisioningStudioAgentsAppGroupIdDsaIdScheduleResult =
  objectOf<PutDecisioningStudioAgentsAppGroupIdDsaIdScheduleResult>({
    frequency: number,
    days_of_week: arrayOf(enumOf<DaysOfWeek>(...(daysOfWeek as DaysOfWeek[]))),
  });
